import { Avatar, Box, Button, styled, Typography } from "@mui/material";
import { useUser } from "../../../lib/hooks";
import Navigation from "./navigation";
import { Link } from "react-router-dom";

const Sidebar = (props) => {

    const { onItemClick, ...restProps } = props;
    const user = useUser();

    return (
        <Root {...restProps}>
            {user && (
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column">
                    {user.Avtar
                        ?
                        <Avatar src={user.avatar} sx={{ width: 64, height: 64, border: "2px solid #fafafa" }} />
                        :
                        <Avatar sx={{ width: 64, height: 64, border: "2px solid #fafafa" }}>{user.firstName ? user.firstName[0] : "A"}</Avatar>
                    }
                    <Typography mt={1.5} fontSize="1.025rem" fontWeight={500} textAlign="center">{user.firstName + " " + user.lastName} عزیز <br /> خوش آمدید</Typography>
                    <Link to="/drive/settings">
                        <Button onClick={onItemClick} fullWidth sx={{ display: { lg: "none" }, color: "inherit", mt: 1 }}>ویرایش پروفایل</Button>
                    </Link>
                </Box>
            )}
            <Navigation onItemClick={onItemClick} />
        </Root>
    )
}
export default Sidebar;

const Root = styled('aside')(({ theme }) => ({
    display: "none",
    [theme.breakpoints.up('lg')]: {
        display: "block",
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        padding: 24,
        width: "20vw",
        height: "100%",
        background: "#0083d3",
        color: "#fff",
        [theme.breakpoints.up('xl')]: { width: "18vw" },
        zIndex: 1001,
        overflowY: "auto",
    }
}));